import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.756 7.173A9 9 0 0 0 11 16a1 1 0 1 1-2 0 11 11 0 0 1 .413-2.986A6 6 0 1 0 9 25h11a9 9 0 0 0 1.756-17.827m-11.595 3.91a11 11 0 0 1 5.63-5.246A11 11 0 1 1 20 27H9a8 8 0 0 1 0-16m1.16.082A8 8 0 0 0 9 11Z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCloud = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCloud);
export default Memo;
